import React from 'react';
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Avatar,
  Typography,
  Chip,
  CircularProgress
} from '@mui/material';
import SectionTitle from '../common/SectionTitle';
import DJCarousel from './DJCarousel';
import { birthdayService } from '../../services/birthdayService';

const TeamBirthdaySection = ({ birthdayUsers, birthdayLoading, currentMonth }) => {
  const monthName = birthdayService.getMonthName(currentMonth);

  return (
    <Box id="team-birthday-section" data-section="team-birthday" sx={{ mt: 6, pb: 4 }}>
      <Container maxWidth="xl">
        <Box sx={{ bgcolor: 'rgba(0, 0, 0, 0.7)', borderRadius: 3, p: { xs: 2, md: 3 }, pb: { xs: 4, md: 5 } }}>
          <Grid container spacing={6}>
            {/* Team Section - Left Side */}
            <Grid item xs={12} lg={9}>
              <SectionTitle
                title="Nossa Equipe"
                subtitle="Conheça nossos talentosos DJs"
                align="center"
                color="#FF6B35"
              />
              <DJCarousel />
            </Grid>

            {/* Birthday Section - Right Side */}
            <Grid item xs={12} lg={3}>
              <SectionTitle
                title="DJs Aniversariantes"
                subtitle={`Comemorando em ${monthName}`}
                align="center"
                diagonalLeft="42%"
                color="#FF6B35"
              />

              <Box sx={{ maxHeight: '500px', overflowY: 'auto', pr: 1 }}>
                {birthdayLoading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                    <CircularProgress sx={{ color: '#FF6B35' }} />
                  </Box>
                ) : birthdayUsers.length > 0 ? (
                  birthdayUsers
                    .sort((a, b) => a.birthday_day - b.birthday_day)
                    .map((user) => {
                      const today = new Date();
                      const isTodayBirthday =
                        user.birthday_day === today.getDate() &&
                        user.birthday_month === today.getMonth() + 1;

                      return (
                        <Card
                          key={user.id}
                          sx={{
                            mb: 2,
                            display: 'flex',
                            alignItems: 'center',
                            background: isTodayBirthday
                              ? 'linear-gradient(135deg, rgba(255, 107, 53, 0.3) 0%, rgba(0, 212, 255, 0.3) 100%)'
                              : 'linear-gradient(135deg, rgba(255, 107, 53, 0.1) 0%, rgba(0, 212, 255, 0.1) 100%)',
                            border: isTodayBirthday
                              ? '2px solid rgba(255, 107, 53, 0.8)'
                              : '2px solid rgba(255, 107, 53, 0.3)',
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              border: '2px solid rgba(255, 107, 53, 0.6)',
                            },
                            transition: 'all 0.3s ease',
                            boxShadow: isTodayBirthday ? '0 0 20px rgba(255, 107, 53, 0.5)' : 'none',
                          }}
                        >
                          <CardContent sx={{ display: 'flex', alignItems: 'center', p: 2, width: '100%' }}>
                            <Avatar
                              src={user.profile_image}
                              imgProps={{ loading: 'lazy', decoding: 'async' }}
                              sx={{
                                width: 50,
                                height: 50,
                                bgcolor: '#FF6B35',
                                fontSize: '1.2rem',
                                mr: 2,
                                border: '2px solid rgba(255, 107, 53, 0.5)',
                              }}
                            >
                              {user.name?.charAt(0) || 'DJ'}
                            </Avatar>
                            <Box sx={{ flexGrow: 1 }}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'white', mb: 0.5 }}>
                                {user.name}
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.8, color: '#00D4FF', mb: 1 }}>
                                🎂 {birthdayService.formatBirthday(user.birthday_day, user.birthday_month)}
                              </Typography>
                              {isTodayBirthday && (
                                <Chip
                                  label="🎉 Hoje é o dia!"
                                  size="small"
                                  sx={{
                                    bgcolor: '#FF6B35',
                                    color: 'white',
                                    fontWeight: 600,
                                    fontSize: '0.7rem',
                                  }}
                                />
                              )}
                            </Box>
                          </CardContent>
                        </Card>
                      );
                    })
                ) : (
                  <Card
                    sx={{
                      background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1) 0%, rgba(0, 212, 255, 0.1) 100%)',
                      border: '2px solid rgba(255, 107, 53, 0.3)',
                      textAlign: 'center',
                      p: 3,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h4"
                        sx={{
                          color: '#FF6B35',
                          mb: 2,
                          fontSize: '3rem',
                        }}
                      >
                        🎂
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          color: 'white',
                          fontWeight: 600,
                          mb: 2,
                        }}
                      >
                        Nenhum aniversariante este mês
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: 'rgba(255, 255, 255, 0.7)',
                          lineHeight: 1.6,
                        }}
                      >
                        Este mês nenhum membro da equipe faz aniversário.
                        Mas não se preocupe, em breve teremos mais celebrações! 🎉
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default TeamBirthdaySection;
